
import React from 'react';
import { Link } from "react-router-dom";
import './App.css';
import brandLogo from './assets/logo_icon.png';


const AboutUs = () => {
  return (
    <section className="about-us-body">
      <div className="about-us" id="about-us">
        <div className="about-us-text-container" id="about-us-text-container">
          <h1> THE STILL PHILOSOPHY </h1>

          <p>The world glorifies speed.</p>
          <p>We believe in the strength of stillness.</p>

          <p>You don't have to rush.</p>
          <p>You don't have to catch up.</p>
          <p>You don't have to become someone else</p>
          <p>Own Your Pace.</p>

          <Link to= '/about'className="button-about">Discover Our Story →</Link>
        </div>
        <div className="about-us-image-container">
          <img src= {brandLogo} alt="" className="about-us-brand-image" />
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
